let prefix

// noinspection JSUnresolvedVariable
switch (process.env.VUE_APP_MODE) {
    case 'prod':
        prefix = '/' //线上网络请求地址前缀 
        break
    case 'ppe':
        prefix = '/api'
        break
    default:
        // prefix = '/api'
        prefix='https://subsc.qxmx.net/'//本地连接上线
        break
}

// noinspection JSUnusedGlobalSymbols
export const apiPrefix = prefix

export default {
    /* api 接口前缀 */
    prefix,
    /* api 接口超时时间 */
    readTimeout: 60 * 1000 * 10,
    /* 安全令牌类型 */
    tokenType: 'mweb',
    /* api 接口返回的错误码 */
    errno: {
        /* 需要安全令牌 */
        requireAccessToken: 1001,
        /* 不是有效的安全临牌 */
        invalidAccessToken: 1002,
        /* 安全令牌已失效 */
        accessTokenExpired: 1003,
        /* 数据完整性验证错误 */
        dataValidationError: 1006,
        /* 接口请求出错 */
        apiCallException: -1,
        /* 接口数据解析异常 */
        apiResultParseException: -2,
        /* token刷新失败 */
        tokenRefreshException: -3
    },

    /* 接口列表 */
    'jwt.refresh': {
        url: '/common/token/refresh',
        withoutJwt: true
    },
    'wxgzh.code2userinfo': {
        url: '/wxgzh/code2userinfo',
        withoutJwt: true
    },
    'wxgzh.jwtmock': {
        url: '/wxgzh/jwtmock',
        withoutJwt: true
    },
    
    /* 接口列表 */
    'home.activity': {
        url: '/wxapp/activity'
    },
    /* 接口列表 */
    'activity.del': {
        url: '/wxapp/activity/detail'
    },
    /* 测试token */
    'test.token': {
        url: '/wxapp/fans/test-token'
    },
    /* 首页模块 */
    'homepageVajraDistrict.list': {
        url: '/wxapp/homepage-vajra-district'
    },
    /* 首页-服务标题描述 */
    'homeServices.list': {
        url: '/wxapp/home-services'
    },
    /* 客服相关配置 */
    'kf.info': {
        url: '/wxapp/sysconfig'
    },
    /* 个人中心广告图 */
    'homepage.popupImages': {
        url: '/wxapp/homepage-popup-images'
    },
    /* 个人信息 */
    'fans.profile': {
        url: '/wxapp/fans/profile'
    },
    /* 获取验证码 */
    'fans.sendcode': {
        url: '/wxapp/member-apply/get-code'
    },
    /* 绑定手机 */
    'bindMobile': {
        url: '/wxapp/member/update-mobile'
    },
    /* 工单列表 */
    'orders.list': {
        url: '/wxapp/work-orders'
    },
    /* 技术员创建工单 */
    'orders.add': {
        url: '/wxapp/work-order'
    },
    /* 工单详情 */
    'orders.del': {
        url: '/wxapp/work-order'
    },
    /* 评价工单 */
    'orders.appraise': {
        url: '/wxapp/work-order/appraise'
    },
    /* 质保期查询 */
    'device.warranty': {
        url: '/wxapp/device-warranty'
    },
    /* 我的客户列表 */
    'my.customer.list': {
        url: '/wxapp/my-customer/items'
    },
    /* 添加客户 */
    'my.customer.add': {
        url: '/wxapp/my-customer/item'
    },
    /* 客户详情 */
    'my.customer.info': {
        url: '/wxapp/my-customer/item'
    },
    /* 添加客户 */
    'my.customer.del': {
        url: '/wxapp/my-customer/item/{id}'
    },
    /* 客户设为默认 */
    'my.customer.default': {
        url: '/wxapp/my-customer/item/set-as-default'
    },
    /* 修改客户 */
    'my.customer.up': {
        url: '/wxapp/my-customer/item/{id}'
    },
    /* 政策协议目录 */
    'article.category': {
        url: '/wxapp/article-category'
    },
    /* 服务政策列表 */
    'category.list': {
        url: '/wxapp/articles'
    },
    /* 服务政策详情 */
    'category.info': {
        url: '/wxapp/articles-info'
    },
    /* 个人中心-工单个数 */
    'order.count': {
        url: '/wxapp/work-order/count'
    },
    /* 通过单号获取工单详情 */
    'order.info': {
        url: '/wxapp/work-order-info'
    },
    /* 设备信息 */
    'product.detail': {
        url: '/wxapp/product-detail'
    },

    /* yyh5发数据给后端 */
    'postcene':{
        url:'/wxapp-api/common/record-param'
    },
    
    /* yyh5 start*/
   /* 图片上传 */
   'image.save':{
    // url:'/common/upload/local/image'
    // url:'/wxapp/image/save'
    // url:"/common/upload/qiniu/image"//七牛云
    url:"/common/upload/base64/image"
   },

   /* 用户信息 */
   'my.userInfo':{
        url:'/wxapp/user/profile',
        withoutJwt: true
    },

    /* 轮播图 */
    'homepage.slideImages': {
        url: '/wxapp/homepage',
        withoutJwt: true
    },

    /* banner图 */
    'homepage.banner': {
        url: '/wxapp/poster',
        withoutJwt: true
    },

    /* 申报人 */
    'declaration.postForm': {
        url: '/wxapp/declare-apply',
        withoutJwt: true
    },

    /* 申报人-put */
    'declaration.postForm.put': {
        url: '/wxapp/declare-apply/{id}',
        withoutJwt: true
    },

    // 是否限制必须买票
    "yy.islimit": {
        url: "/wxapp/reservation-restrict",
        withoutJwt: true
    },
    /* 预约申请,我的二维码,申请记录 */
    "yy.postForm":{
        url: "/wxapp/reservation",
        withoutJwt: true
    },

    /* 预约状态(申请的二维码是否通过) */
    "yy.state":{
        url: "/wxapp/reservation-audit",
        withoutJwt: true
    },

     /* 预约状态(申请的二维码是否通过)-put */
     "yy.state.put":{
        url: "/wxapp/reservation/{id}",
        withoutJwt: true
    },

    /* 核销记录 */
    'hexiaoList': {
        url: '/wxapp/verification-log',
        withoutJwt: true
    },

    /* 核销 */
    "hexiao":{
        url:"/wxapp/verification",
        withoutJwt: true
    },

    /* 核销详情 */
    'hexiaoListXq': {
        url: '/wxapp/reservation-detail',
        withoutJwt: true
    },

    /* 后端要的登录 */
    'denglu': {
        url: '/wxapp/user/login',
        withoutJwt: true
    },

    /* 获取sdk参数 */
   'getsdfkcfg': {
        url: '/wxapp/skip-arguments',
        withoutJwt: true
    },

}